import Vue from 'vue';
import events from '../../events/events';

// pre-populate everything thats is needed reactive right from the start!
const state =
{
    count: 0,
    areas: {},
};

const actions =
{
    up ({commit})
    {
        commit('UP');
    },
    
    down ({commit})
    {
        commit('DOWN');
    },
    
    areaUp ({commit}, area)
    {
        commit('AREA_UP', area);
    },
    
    areaDown ({commit}, area)
    {
        commit('AREA_DOWN', area);
    },
};

const mutations =
{
    UP (state)
    {
        state.count++;
    },
    
    DOWN (state)
    {
        let count = state.count - 1;
        state.count = Math.max(count, 0);
    },
    
    AREA_UP (state, area)
    {
        if (typeof state.areas[area] === 'undefined') state.areas[area] = 0;
        // If value is zero, up was called first time
        if (state.areas[area] === 0) events.$emit(area, 'on');
        state.areas[area]++;
    },
    
    AREA_DOWN (state, area)
    {
        let count = state.areas[area] - 1;
        state.areas[area] = Math.max(count, 0);
        // If value is zero, down was called last time
        if (state.areas[area] === 0) events.$emit(area, 'off');
    },
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/loader.js